module.exports = "<svg version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink xmlns:a=http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/ x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\" style=\"enable-background:new 0 0 16 16\" xml:space=preserve> <style type=text/css>.st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}</style> <defs> </defs> <g> <path class=st0 d=M4,8.8l1.6,2.3c0.1,0.2,0.3,0.3,0.6,0.3c0.2,0,0.4-0.1,0.6-0.3L12,4.6 /> <circle class=st0 cx=8 cy=8 r=7.5 /> </g> </svg> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./app/statamic/resources/svg/radio.svg
// module id = 461
// module chunks = 0